import { render, staticRenderFns } from "./AddCriteriaModal.vue?vue&type=template&id=fc6b99be&scoped=true"
import script from "./AddCriteriaModal.vue?vue&type=script&lang=js"
export * from "./AddCriteriaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6b99be",
  null
  
)

export default component.exports